import { Button, Group, Modal } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { IconFileExport, IconX } from '@tabler/icons-react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import useFetch from '../helpers/useFetch';
import useIsValidReport from '../helpers/useIsValidReport';
import ErrorMessage from './ErrorMessage';
import ReportsForm from './Reports/ReportsForm';

const MetricsExportButton = ({ scope, periodStart, periodEnd, id }) => {
  const { user } = useSelector((state) => state.auth);
  const { domain } = useSelector((state) => state.domain);
  const [report, setReport] = useState();
  const [userError, setUserError] = useState();
  const isValidReport = useIsValidReport(report);

  const fetch = useFetch();

  const createReport = () => {
    fetch(`/api/admin/accounts/${domain.accountId}/domains/${domain.id}/exports`, {
      method: 'POST',
      body: JSON.stringify(report),
    })
      .then(() => {
        notifications.show({
          title: 'Export Created',
          message: 'You will receive your export via email shortly!',
          color: 'success',
        });
        setReport(undefined);
      })
      .catch(setUserError);
  };

  const ids = [id].filter((i) => i !== null && i !== undefined).map(parseInt);

  return scope ? (
    <>
      <Button
        size="sm"
        variant="default"
        onClick={() =>
          setReport({
            name: `New ${scope} export @ ${new Date().toISOString()}`,
            type: 'oneTime',
            scope,
            periodStart: periodStart ? `${periodStart}T00:00:00` : periodStart,
            periodEnd: periodEnd ? `${periodEnd}T23:59:59` : periodEnd,
            elements: ids,
            recipients: [user.email],
            selection: ids.length > 0 ? 'specific' : 'all',
          })
        }
        ml="sm"
        leftSection={<IconFileExport size={16} />}
      >
        Export
      </Button>
      <Modal size="xl" opened={!!report} onClose={() => setReport(undefined)} title="Create Export">
        <ReportsForm report={report} handleChange={(e) => setReport({ ...report, [e.target.name]: e.target.value })} />
        <Group justify="flex-end" mt="md">
          <Button variant="default" onClick={() => setReport(undefined)} leftSection={<IconX size={16} />}>
            Cancel
          </Button>
          <Button onClick={createReport} disabled={!isValidReport} leftSection={<IconFileExport size={16} />}>
            Create Export
          </Button>
        </Group>
        {userError && <ErrorMessage message={userError.message} />}
      </Modal>
    </>
  ) : (
    ''
  );
};

export default MetricsExportButton;
